import { useSeo } from "../lib/seo";
import { CONTACT } from "../data/site";
import { Lines, Reveal } from "../components/motion";
import { Cta, Eyebrow } from "../components/ui-bits";
import { ContactForm } from "../components/ContactForm";

export default function Contatti() {
  useSeo("Contatti: consulenza social e comunicazione a Como e Brianza", "Contatta B Digital Studio per una consulenza su social media, foto e video, Meta Ads e strategie di lancio. Operiamo tra Como, Monza e Brianza, Varese e Lecco.");
  return (
    <section className="px-5 pb-24 pt-36 sm:px-10 md:pb-36 md:pt-48 lg:px-16" data-testid="contatti-page">
      <div className="grid grid-cols-12 gap-y-16 lg:gap-x-16">
        <div className="col-span-12 lg:col-span-5">
          <Reveal delay={0.5}><Eyebrow>Contatti</Eyebrow></Reveal>
          <Lines as="h1" onLoad delay={0.55} lines={["Parliamo", "del tuo brand."]} className="mt-8 text-5xl leading-[1.05] sm:text-6xl lg:text-7xl" />
          <Reveal delay={0.9}>
            <p className="mt-10 max-w-md text-base leading-relaxed text-ink/80 md:text-lg">
              Raccontaci chi sei, a che punto è la tua comunicazione e cosa vorresti ottenere. Rispondiamo personalmente a ogni richiesta.
            </p>
            <div className="mt-10 flex flex-col items-start gap-3">
              <Cta href={CONTACT.bookingIrene} target="_blank" rel="noopener noreferrer" testid="contact-call-irene">Prenota una call con Irene</Cta>
              <Cta href={CONTACT.bookingGiulia} target="_blank" rel="noopener noreferrer" variant="outline" testid="contact-call-giulia">Prenota una call con Giulia</Cta>
            </div>
            <dl className="mt-14 space-y-6 text-sm">
              <div><dt className="eyebrow">Dove siamo</dt><dd className="mt-2 text-base">Lombardia, tra le province di Como, Monza e Brianza, Varese e Lecco</dd></div>
            </dl>
          </Reveal>
        </div>
        <Reveal delay={0.7} className="col-span-12 lg:col-span-6 lg:col-start-7">
          <div className="bg-white/70 p-6 sm:p-10 md:p-12">
            <ContactForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
